// extracted by mini-css-extract-plugin
module.exports = {"base":"base--ACzQG2","number":"number--gtyT3j","active":"active--nrnu5u","text":"text--lEvV4w","checked":"checked--TGua7k"};